import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faGears, 
  faUserGroup, 
  faCirclePlay, 
  faChartLine 
} from '@fortawesome/free-solid-svg-icons';

const SectionContainer = styled.section`
  padding: 5rem 2rem;
  background: #f7fafc;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const Title = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  color: #2d3748;
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  color: #4a5568;
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
`;

const StepsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 100px;
    left: 0;
    right: 0;
    height: 2px;
    background: #e2e8f0;
    z-index: 0;

    @media (max-width: 1024px) {
      display: none;
    }
  }
`;

const Step = styled.div`
  text-align: center;
  position: relative;
  z-index: 1;
`;

const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  color: #4299e1;
  font-size: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 2px solid #4299e1;
`;

const StepNumber = styled.div`
  position: absolute;
  top: -10px;
  right: -10px;
  background: #4299e1;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.9rem;
`;

const StepTitle = styled.h3`
  font-size: 1.25rem;
  color: #2d3748;
  margin-bottom: 1rem;
`;

const StepDescription = styled.p`
  color: #4a5568;
  line-height: 1.6;
`;

const steps = [
  {
    icon: faGears,
    title: "Easy Setup",
    description: "Configure your wheel with custom branding, participant limits, and matching preferences in minutes."
  },
  {
    icon: faUserGroup,
    title: "Invite Participants",
    description: "Share a unique link with your participants or integrate with your existing event platform."
  },
  {
    icon: faCirclePlay,
    title: "Start Networking",
    description: "Watch as participants join, interact, and make meaningful connections through our engaging interface."
  },
  {
    icon: faChartLine,
    title: "Track Results",
    description: "Access detailed analytics on participation, engagement, and successful connections."
  }
];

export const HowItWorksSection: React.FC = () => {
  return (
    <SectionContainer>
      <Content>
        <Header>
          <Title>How It Works</Title>
          <Subtitle>
            Get started with SpinToConnect in four simple steps and transform 
            your virtual networking experience.
          </Subtitle>
        </Header>
        <StepsContainer>
          {steps.map((step, index) => (
            <Step key={index}>
              <IconContainer>
                <FontAwesomeIcon icon={step.icon} />
                <StepNumber>{index + 1}</StepNumber>
              </IconContainer>
              <StepTitle>{step.title}</StepTitle>
              <StepDescription>{step.description}</StepDescription>
            </Step>
          ))}
        </StepsContainer>
      </Content>
    </SectionContainer>
  );
}; 